import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useUserback } from "@userback/react";

/**
 * Attaches the logged-in user to Userback feedback reports.
 *
 * Renders nothing — it only reacts to auth state. Must live inside both the
 * redux <Provider> and <UserbackProvider>. Without this, feedback still works
 * but arrives anonymous, with no way to tell who reported what.
 */
const UserbackIdentify = () => {
  const user = useSelector((state) => state.auth.user);
  const { identify } = useUserback();

  useEffect(() => {
    if (!identify || !user?._id) return;

    const first = user.first_name || user.company_first_name || "";
    const last = user.last_name || user.company_last_name || "";
    const name = `${first} ${last}`.trim();

    try {
      identify(String(user._id), {
        name: name || user.email || "Unknown user",
        email: user.email || "",
      });
    } catch (error) {
      // Never let a feedback-widget failure break the app.
      console.error("Userback identify failed:", error);
    }
  }, [identify, user]);

  return null;
};

export default UserbackIdentify;
